import React, { useEffect, useState } from "react";
import { showToast } from "../../../services/toastifyservices";
import { handleSession } from "../../../api/apiSessionHandle";
import { useNavigate } from "react-router-dom";
import { getaxiosadminRequestWithToken, postaxiosadminRequestWithToken, getAdminAssistentsPool } from "../../../api/api";
import { FaRegEdit, FaPlayCircle, FaComments, FaChartBar } from "react-icons/fa";
import { FiTrash2 } from "react-icons/fi";
import { Spinner, Modal, Button } from "react-bootstrap";
import CommonSpinner from "../../../services/commonSpinner";
import AssistantDetail from "../../../components/Assistant/AssistantDetails";
import Swal from "sweetalert2";
import { PaginationControls } from "../../../components/pagination";
import './communication.css';
import endpoints from "../../../api/EndPoints";

const Communication = () => {
    const navigate = useNavigate();
    const [communicationdata, setcommunicationdata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [startDate, setstartDate] = useState('');
    const [SelectOperator, setSelectOperator] = useState('');
    const [selectedCall, setSelectedCall] = useState(null);
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [showRecordingModal, setShowRecordingModal] = useState(false);
    const [showAnalysisModal, setShowAnalysisModal] = useState(false);

    const handleSearch = async () => {
        try {
            setLoading(true);
            let queryParams = new URLSearchParams();
            if (SelectOperator) {
               if(!startDate){
                showToast('error', "please select date"); 
                return
               }
            }
            if (startDate && SelectOperator) {
                queryParams.append(SelectOperator, startDate);
            }

            // Construct the final URL
            let url = endpoints.GetCallList;
            if (queryParams.toString()) {
                url += `?${queryParams.toString()}`;
            }

            const response = await getaxiosadminRequestWithToken(url);

            if (response.success) {
                var responsedata = response.data;
                console.log("responsedata", responsedata)
                setcommunicationdata(responsedata);
            }
        } catch (error) {
            setLoading(false);
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    const formatTimestamp = (timestamp) => {
        return new Date(parseInt(timestamp)).toLocaleTimeString();
    };

    const MessageModal = ({ call, show, onHide }) => (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Call Messages</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="chat-container">
                    {Object.entries(call?.messages || {}).map(([key, message]) => (
                        message.role !== 'tool_calls' && message.role !== 'tool_call_result' && (
                            <div key={key} className={`message ${message.role === 'bot' ? 'bot' : 'user'}`}>
                                <div className="message-content">
                                    <p>{message.message}</p>
                                    <small>{formatTimestamp(message.time)}</small>
                                </div>
                            </div>
                        )
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    );

    const RecordingModal = ({ call, show, onHide }) => (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Call Recording</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <audio controls className="w-100">
                    <source src={call?.recordingUrl} type="audio/wav" />
                    Your browser does not support the audio element.
                </audio>
            </Modal.Body>
        </Modal>
    );

    const AnalysisModal = ({ call, show, onHide }) => (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Call Analysis</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="analysis-container">
                    <h5>Summary</h5>
                    <p>{call?.analysis?.summary}</p>
                    <h5>Success Evaluation</h5>
                    <div className={`badge ${call?.analysis?.successEvaluation === 'true' ? 'bg-success' : 'bg-danger'}`}>
                        {call?.analysis?.successEvaluation === 'true' ? 'Success' : 'Failed'}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );

    return (
        <div className="mt-3 p-2 md:p-10 bg-gray-200">
            <div className="card">
                <span className="text-start font-bold ml-4 p-2 headingtext">
                    Calls Forwarding
                </span>
            </div>
            <div className="card p-3">
                <div className="row">
                    <div className="col-md-3">
                        <label className="form-label font-bold">Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={startDate}
                            onChange={(e) => setstartDate(e.target.value)}
                        />
                    </div>
                    <div className="col-md-3 mb-1">
                        <label className="form-label font-bold">Operator Name</label>
                        <select
                            className="form-select"
                            value={SelectOperator}
                            onChange={(e) => setSelectOperator(e.target.value)}
                        >
                            <option value="">Select Operator</option>
                            <option value="createdAtGt">&gt;</option>
                            <option value="createdAtLt">&lt;</option>
                            <option value="createdAtGe">&ge;</option>
                            <option value="createdAtLe">&le;</option>
                        </select>

                    </div>
                    <div className="col-md-3 mt-2">
                        <button
                            className="btn btn-primary fw-bold btncolor mt-4"
                            onClick={handleSearch}
                        >
                            SEARCH
                        </button>
                    </div>


                </div>
            </div>

            <div className="card">
                <div className="table-container">
                    <table className="table table-striped table-hover">
                        <thead className="table-header table-primary">
                            <tr>
                                <th>Customer Number</th>
                                <th>Ended Reason</th>
                                <th>Forwarded Phone Number</th>
                                <th>Team</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {loading ? (
                                <tr><td colSpan="7"><CommonSpinner /></td></tr>
                            ) : communicationdata.length > 0 ? (
                                communicationdata.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.customerNumber}</td>
                                        <td>{data.endedReason}</td>
                                        <td>{data.forwardedPhoneNumber}</td>
                                        <td>{data.team}</td>
                                        <td>
                                            <div className="d-flex gap-2">
                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => {
                                                        setSelectedCall(data);
                                                        setShowMessageModal(true);
                                                    }}
                                                >
                                                    <FaComments />
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-success"
                                                    onClick={() => {
                                                        setSelectedCall(data);
                                                        setShowRecordingModal(true);
                                                    }}
                                                >
                                                    <FaPlayCircle />
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-info"
                                                    onClick={() => {
                                                        setSelectedCall(data);
                                                        setShowAnalysisModal(true);
                                                    }}
                                                >
                                                    <FaChartBar />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Add Modals */}
            <MessageModal
                call={selectedCall}
                show={showMessageModal}
                onHide={() => setShowMessageModal(false)}
            />
            <RecordingModal
                call={selectedCall}
                show={showRecordingModal}
                onHide={() => setShowRecordingModal(false)}
            />
            <AnalysisModal
                call={selectedCall}
                show={showAnalysisModal}
                onHide={() => setShowAnalysisModal(false)}
            />
        </div>
    );
};

export default Communication;
